import { put, take, takeLatest, call, select } from 'redux-saga/effects';

import contactService from 'services/contactService';

import { facilityDrawer, open, save, types } from './actions';
import { MODES } from './constants';
import { getAccountId, getFacilityId, getMode } from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_REQUEST, watchInitiateDrawer);
  yield takeLatest(types.SAVE_REQUEST, watchSaveFacility);
}

function* watchInitiateDrawer(action) {
  try {
    const { callBack } = action.payload;

    const mode = yield select(getMode);
    if (mode === MODES.EDIT) {
      // fetch current facility
      const facilityId = yield select(getFacilityId);
      const facility = yield call(
        contactService.accounts.facilities.get,
        facilityId,
      );

      yield put(facilityDrawer.setFacility({ facility }));
    }

    yield put(open.success());

    if (callBack) {
      const action = yield take(types.SAVE_SUCCESS);
      callBack({
        facilityId: action.payload.facilityId,
        facility: action.payload.facility,
      });
    }
  } catch (error) {
    yield put(open.error(error));
  }
}

function* watchSaveFacility(action) {
  try {
    const {
      address1,
      address2,
      attention,
      city,
      country,
      name,
      postalCode,
      salespersonId,
      state,
    } = action.payload;

    const requestData = {
      address: {
        address1,
        address2,
        city,
        country,
        postalCode,
        state,
      },
      attention,
      name,
      salespersonId,
    };

    const mode = yield select(getMode);
    let facilityId = yield select(getFacilityId);
    let facility;
    if (mode == MODES.CREATE) {
      const accountId = yield select(getAccountId);
      const response = yield call(
        contactService.accounts.facilities.create,
        accountId,
        requestData,
      );
      facilityId = response.id;
      facility = response;
    } else {
      facility = yield call(
        contactService.accounts.facilities.update,
        facilityId,
        requestData,
      );
    }

    yield put(save.success({ facilityId, facility }));
  } catch (error) {
    yield put(save.error(error));
  }
}
